import styled from "styled-components";

export const Container = styled.div`
  display: flex;
`;

export const ContainerHome = styled.div`
  display: flex;
  width: 100%;
  animation: fadein 300ms;
  @keyframes fadein {
    0% {
 opacity:0;
 }
 50%{
 opacity:0.5;
 }
 100% {
 opacity:1;
 }
  }
  //padding-left: 400px;
  //padding-right: 400px;
`;

export const ContainerTitulo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Button = styled.button`
position: absolute;
  font-family: "Disco";
  font-weight: bold;
  font-size: 15px;
  letter-spacing: 3px;
  border: 3px solid #89dddb;
  border-radius: 30px;
  box-shadow: 0px 0px 45px #51c0dc;
  width: 125px;
  height: 50px;
  margin-top: 120px;
  background-color: black;
  color: #89dddb;
  cursor: pointer;
  animation: fadein 3s;
  @keyframes fadein {
    0% {
      opacity: 0;
    }
    25% {
      opacity: 0.2;
    }
    50% {
      opacity: 0.5;
    }
    75% {
      opacity: 0.7;
    }
    100% {
      opacity: 1;
    }
  }

  &:hover {
    background-color: #89dddb;
    color: black;
    transition: 700ms;
    transform: scale(1.1);
  }
`;
